import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ef-confirm__msg" }
const _hoisted_2 = { class: "ef-confirm__buttons" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Oui")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Non")

import Modale from '@/modales/Modale.vue';
import Button from '@/components/Button.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  msg: { type: String, default: '' },
  open: { type: Boolean, default: false },
},
  emits: ['close', 'valid'],
  setup(__props, { emit }) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modale, {
    class: "ef-confirm",
    open: __props.open,
    width: "30%",
    height: "30%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, " Etes vous sur de vouloir " + _toDisplayString(__props.msg) + " ? ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('valid')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})